"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _CameraPlaneRestrictionApi_cameraPlaneRestriction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraPlaneRestrictionApi = void 0;
const AbstractRestrictionApi_1 = require("../AbstractRestrictionApi");
class CameraPlaneRestrictionApi extends AbstractRestrictionApi_1.AbstractRestrictionApi {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(restriction) {
        super(restriction);
        // #region Properties (1)
        _CameraPlaneRestrictionApi_cameraPlaneRestriction.set(this, void 0);
        __classPrivateFieldSet(this, _CameraPlaneRestrictionApi_cameraPlaneRestriction, restriction, "f");
    }
}
exports.CameraPlaneRestrictionApi = CameraPlaneRestrictionApi;
_CameraPlaneRestrictionApi_cameraPlaneRestriction = new WeakMap();
//# sourceMappingURL=CameraPlaneRestrictionApi.js.map